import link from '../../link/default';

const light = (params) => link.light(params);

export default light;
